import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';
import {RouterModule} from '@angular/router';
import {ProfilePageComponent} from './profile-page.component';
import {PatternsModule} from '../../modules/patterns/patterns.module';
import {BaseModule} from '../../modules/base/base.module';
import {DecorationModule} from '../../modules/decoration/decoration.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        PatternsModule,
        BaseModule,
        DecorationModule,
        RouterModule.forChild([{path: '', component: ProfilePageComponent}])
    ],
    declarations: [ProfilePageComponent]
})
export class ProfilePageModule {
}
